module.exports = __webpack_public_path__ + "d2d5a045354fa1058010eba9cd4fb9e0.jpg";